/**
 * Product Type Names Mapping
 * Maps SVSPP codes to their display names
 * Based on tblc_SVSPProduct table
 */

export const PRODUCT_TYPE_NAMES: Record<string, string> = {
  '1110': 'Convertible Certificate',
  '1230': 'Barrier Reverse Convertible',
  '1260': 'Express Certificate',
  '1220': 'Reverse Convertible',
  '1410': 'Reference Entity Certificate with Conditional Capital Protection',
  '1100': 'Capital Protection Certificate with Participation',
  '1140': 'Capital Protection Certificate with Coupon',
  '1300': 'Tracker Certificate',
  '1310': 'Outperformance Certificate',
  '1320': 'Bonus Certificate',
  '9999': 'Various Products',
  '1200': 'Discount Certificate',
  '1130': 'Barrier Capital Protection Certificate',
  '2100': 'Warrant',
  '2110': 'Spread Warrant',
  '2200': 'Knock-out Warrant',
  '2210': 'Mini-Futures',
};

/**
 * Get product type name by code with code prefix
 * @param code - SVSPP product code
 * @returns Product type name with code (e.g., "1230 - Barrier Reverse Convertible")
 */
export const getProductTypeName = (code: string): string => {
  const name = PRODUCT_TYPE_NAMES[code];
  return name ? `${code} - ${name}` : code;
};

/**
 * Get product type name by code without prefix
 * @param code - SVSPP product code
 * @returns Product type name only or the code itself if not found
 */
export const getProductTypeNameOnly = (code: string): string => {
  return PRODUCT_TYPE_NAMES[code] || code;
};

/**
 * Get all product type entries as array
 * @returns Array of {code, name} objects
 */
export const getProductTypeEntries = (): Array<{ code: string; name: string }> => {
  return Object.entries(PRODUCT_TYPE_NAMES).map(([code, name]) => ({ code, name }));
};
